import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/chat/inVideoSuccess.svg'
import _imports_1 from '@/assets/chat/outVideoSuccess.svg'
import _imports_2 from '@/assets/chat/inVoiceSuccess.svg'
import _imports_3 from '@/assets/chat/outVoiceSuccess.svg'
import _imports_4 from '@/assets/chat/defaultPhone.svg'
import _imports_5 from '../../../assets/chat/empty-img-default.svg'


const _withScopeId = n => (_pushScopeId("data-v-31d50144"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mailItem" }
const _hoisted_2 = {
  key: 0,
  class: "infoBox"
}
const _hoisted_3 = {
  key: 0,
  class: "topBox"
}
const _hoisted_4 = { class: "text" }
const _hoisted_5 = { class: "username" }
const _hoisted_6 = { class: "topBox" }
const _hoisted_7 = { class: "skeletonMail" }
const _hoisted_8 = {
  class: /*#__PURE__*/_normalizeClass(['numbers', 'borderRadius'])
}
const _hoisted_9 = { class: "imgBox1" }
const _hoisted_10 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_11 = {
  key: 1,
  src: _imports_1,
  alt: ""
}
const _hoisted_12 = {
  key: 2,
  src: _imports_2,
  alt: ""
}
const _hoisted_13 = {
  key: 3,
  src: _imports_3,
  alt: ""
}
const _hoisted_14 = {
  key: 4,
  src: _imports_4,
  alt: ""
}
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "time" }
const _hoisted_17 = { class: "status" }
const _hoisted_18 = {
  key: 1,
  class: "empty"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "empty-img",
  alt: ""
}, null, -1))
const _hoisted_20 = { class: "empty-text" }

import { computed, ref, watch } from "vue";
import { getFirstXLetters, gaEvent } from "@/utils/format";
import { useStore } from "vuex";
import { dateFormat } from "@/utils/format";
import emitter from "@/utils/eventBus";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'phoneContentItem',
  props: {
  phoneItemDetail: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const { t } = useI18n();



const store = useStore();

const isDemoRef = computed(() => store.state.isDemo);
const currentLang = computed(() => store.state.currentLang);

// 获取当前点击项的详细信息
const mailItemDetail = computed(() => {
  return store.state.clickMailItemDetail;
});

const activeTabName = computed(() => {
  return store.state.activeTabName;
});

// 控制骨架屏是否出现
const skeletonLoading = ref(true);

emitter.on("closeLoading", () => {
  // console.log('隐藏骨架屏');
  skeletonLoading.value = false;
});

const newStatus = ref();
watch(
  () => props.phoneItemDetail,
  () => {
    if (!props.phoneItemDetail) return;
    if (!props.phoneItemDetail.status) return;
    if (props.phoneItemDetail.status == "incoming video") {
      newStatus.value = { name: computed(() => t("chat.incomingVideo")) };
    } else if (props.phoneItemDetail.status == "outgoing video") {
      newStatus.value = { name: computed(() => t("chat.outgoingVideo")) };
    } else if (props.phoneItemDetail.status == "incoming voice") {
      newStatus.value = { name: computed(() => t("chat.incomingVoice")) };
    } else if (props.phoneItemDetail.status == "outgoing voice") {
      newStatus.value = { name: computed(() => t("chat.outgoingVoice")) };
    } else {
      newStatus.value = { name: props.phoneItemDetail.status };
    }
  },
  {
    immediate: true,
  }
);

return (_ctx: any,_cache: any) => {
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (activeTabName.value == 'third' &&
      __props.phoneItemDetail &&
      Object.keys(__props.phoneItemDetail).length
      )
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (!skeletonLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_el_avatar, { class: "avatar" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(getFirstXLetters)(__props.phoneItemDetail.contact_name, 3) || "--"), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_5, _toDisplayString(__props.phoneItemDetail.contact_name || "--"), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_el_skeleton, {
              style: {"--el-skeleton-circle-size":"68px","width":"150px"},
              loading: skeletonLoading.value,
              animated: true
            }, {
              template: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_el_skeleton_item, {
                    variant: "circle",
                    style: {"margin-bottom":"12px"}
                  }),
                  _createVNode(_component_el_skeleton_item, {
                    variant: "text",
                    style: {"width":"100%"}
                  })
                ])
              ]),
              _: 1
            }, 8, ["loading"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              (__props.phoneItemDetail.status == 'incoming video')
                ? (_openBlock(), _createElementBlock("img", _hoisted_10))
                : (__props.phoneItemDetail.status == 'outgoing video')
                  ? (_openBlock(), _createElementBlock("img", _hoisted_11))
                  : (__props.phoneItemDetail.status == 'incoming voice')
                    ? (_openBlock(), _createElementBlock("img", _hoisted_12))
                    : (__props.phoneItemDetail.status == 'outgoing voice')
                      ? (_openBlock(), _createElementBlock("img", _hoisted_13))
                      : (_openBlock(), _createElementBlock("img", _hoisted_14))
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(['number', currentLang.value == 'ar' ? 'rightText' : ''])
            }, [
              _createElementVNode("div", null, [
                (!skeletonLoading.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(dateFormat)(__props.phoneItemDetail.date, "YYYY-MM-DD HH:mm") || "--"), 1),
                      _createElementVNode("div", _hoisted_17, _toDisplayString(newStatus.value.name || "--"), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_skeleton, {
                  style: {"width":"130px"},
                  loading: skeletonLoading.value,
                  animated: true
                }, {
                  template: _withCtx(() => [
                    _createVNode(_component_el_skeleton_item, { style: {"width":"100%"} }),
                    _createVNode(_component_el_skeleton_item, { style: {"width":"80%"} })
                  ]),
                  _: 1
                }, 8, ["loading"])
              ])
            ], 2)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t("chat.noInfoText")), 1)
        ]))
  ]))
}
}

})